import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateLocationForEventAccountMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  event_account_id: Types.Scalars['ID'];
  type?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateLocationForEventAccountMutation = { __typename?: 'Mutation', createItemLocation: { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null } | null } };


export const CreateLocationForEventAccountDocument = gql`
    mutation createLocationForEventAccount($name: String!, $event_account_id: ID!, $type: String) {
  createItemLocation(
    name: $name
    event_account_id: $event_account_id
    type: $type
  ) {
    id
    name
    type
    event_account {
      id
      name
      item_locations {
        id
        name
      }
    }
  }
}
    `;
export type CreateLocationForEventAccountMutationFn = Apollo.MutationFunction<CreateLocationForEventAccountMutation, CreateLocationForEventAccountMutationVariables>;

/**
 * __useCreateLocationForEventAccountMutation__
 *
 * To run a mutation, you first call `useCreateLocationForEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationForEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationForEventAccountMutation, { data, loading, error }] = useCreateLocationForEventAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      event_account_id: // value for 'event_account_id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateLocationForEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationForEventAccountMutation, CreateLocationForEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationForEventAccountMutation, CreateLocationForEventAccountMutationVariables>(CreateLocationForEventAccountDocument, options);
      }
export type CreateLocationForEventAccountMutationHookResult = ReturnType<typeof useCreateLocationForEventAccountMutation>;
export type CreateLocationForEventAccountMutationResult = Apollo.MutationResult<CreateLocationForEventAccountMutation>;
export type CreateLocationForEventAccountMutationOptions = Apollo.BaseMutationOptions<CreateLocationForEventAccountMutation, CreateLocationForEventAccountMutationVariables>;